<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/concierges/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/concierges/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Заказы',
                        url: `/concierges/${this.$route.params.id}/orders`,
                    },
                ],
            };
        },
    };
</script>
